// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var Level1ItemType;
(function (Level1ItemType) {
    Level1ItemType[Level1ItemType["Last"] = 0] = "Last";
    Level1ItemType[Level1ItemType["Open"] = 1] = "Open";
    Level1ItemType[Level1ItemType["ChangePercent"] = 2] = "ChangePercent";
    Level1ItemType[Level1ItemType["High"] = 3] = "High";
    Level1ItemType[Level1ItemType["Volume"] = 4] = "Volume";
    Level1ItemType[Level1ItemType["Low"] = 5] = "Low";
    Level1ItemType[Level1ItemType["IndicativeAuctionPrice"] = 6] = "IndicativeAuctionPrice";
    Level1ItemType[Level1ItemType["SettlementPrice"] = 7] = "SettlementPrice";
    Level1ItemType[Level1ItemType["PrevSettlementPrice"] = 8] = "PrevSettlementPrice";
    Level1ItemType[Level1ItemType["VWAP"] = 9] = "VWAP";
    Level1ItemType[Level1ItemType["ReferencePrice"] = 10] = "ReferencePrice";
    Level1ItemType[Level1ItemType["Ask"] = 11] = "Ask";
    Level1ItemType[Level1ItemType["Spread"] = 12] = "Spread";
    Level1ItemType[Level1ItemType["LastTime"] = 13] = "LastTime";
    Level1ItemType[Level1ItemType["ETB"] = 14] = "ETB";
    Level1ItemType[Level1ItemType["PrevClose"] = 15] = "PrevClose";
    Level1ItemType[Level1ItemType["Change"] = 16] = "Change";
    Level1ItemType[Level1ItemType["Bid"] = 17] = "Bid";
    Level1ItemType[Level1ItemType["BidSize"] = 18] = "BidSize";
    Level1ItemType[Level1ItemType["AskSize"] = 19] = "AskSize";
    Level1ItemType[Level1ItemType["LastSize"] = 20] = "LastSize";
    Level1ItemType[Level1ItemType["OpenInterest"] = 21] = "OpenInterest";
    Level1ItemType[Level1ItemType["BidSource"] = 22] = "BidSource";
    Level1ItemType[Level1ItemType["AskSource"] = 23] = "AskSource";
    Level1ItemType[Level1ItemType["LastSource"] = 24] = "LastSource";
    Level1ItemType[Level1ItemType["Funding"] = 25] = "Funding";
    Level1ItemType[Level1ItemType["Countdown"] = 26] = "Countdown";
    Level1ItemType[Level1ItemType["AuctionStart"] = 27] = "AuctionStart";
    Level1ItemType[Level1ItemType["AuctionEnd"] = 28] = "AuctionEnd";
    Level1ItemType[Level1ItemType["LastUpdateTime"] = 29] = "LastUpdateTime";
    Level1ItemType[Level1ItemType["CurrentSession"] = 30] = "CurrentSession";
    Level1ItemType[Level1ItemType["TradingStatus"] = 31] = "TradingStatus";
    Level1ItemType[Level1ItemType["TradedValue"] = 32] = "TradedValue";
    Level1ItemType[Level1ItemType["OffExchangeVolume"] = 33] = "OffExchangeVolume";
    Level1ItemType[Level1ItemType["OffExchangeValue"] = 34] = "OffExchangeValue";
    Level1ItemType[Level1ItemType["NormalMarketSize"] = 35] = "NormalMarketSize";
    Level1ItemType[Level1ItemType["LimitHigh"] = 36] = "LimitHigh";
    Level1ItemType[Level1ItemType["LimitLow"] = 37] = "LimitLow";
    Level1ItemType[Level1ItemType["RemainingQty"] = 38] = "RemainingQty";
    Level1ItemType[Level1ItemType["RemainingQtySide"] = 39] = "RemainingQtySide";
    Level1ItemType[Level1ItemType["TotalBuyQty"] = 40] = "TotalBuyQty";
    Level1ItemType[Level1ItemType["TotalSellQty"] = 41] = "TotalSellQty";
    Level1ItemType[Level1ItemType["AvgTradedPrice"] = 42] = "AvgTradedPrice";
    Level1ItemType[Level1ItemType["FiftyTwoWeekHighPrice"] = 43] = "FiftyTwoWeekHighPrice";
    Level1ItemType[Level1ItemType["FiftyTwoWeekLowPrice"] = 44] = "FiftyTwoWeekLowPrice";
    Level1ItemType[Level1ItemType["NSEValue"] = 45] = "NSEValue";
    Level1ItemType[Level1ItemType["DPR"] = 46] = "DPR";
    Level1ItemType[Level1ItemType["LastTradedTime"] = 47] = "LastTradedTime";
})(Level1ItemType || (Level1ItemType = {}));
